module.exports = __webpack_public_path__ + "static/media/artunity-login-userflow.a79b6044.jpg";